<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" [routerLink]="['/users']" [queryParams]="{ tab: isShopUser ? 'shop-user' : 'non-shop-user' }">User Management</a
  ><span>/ {{ user?.username }}</span>
</div>
<!-- Page Header -->
<div class="page-header m-b-12">
  <div class="title-section">
    <h2 class="page-title">
      {{ user?.username || '-' }}
    </h2>

    <div class="last-updated">
      Last updated on {{ user?.updateTimestamp ? (user?.updateTimestamp | date: 'medium') : '-' }} by {{ user?.updatedByUsername || '-' }}
    </div>
  </div>

  <div class="header-actions">
    @if (authPolicy.canAddEditUsers && user?.isActive !== false) {
      <mc-button
        fit="small"
        variant="outlined"
        icon="pencil"
        label="Edit"
        (click)="onEditClicked()"
        (keydown.enter)="onEditClicked()"
        (keydown.space)="$event.preventDefault(); onEditClicked()"
        tabindex="0">
      </mc-button>
    }

    <mc-button
      fit="small"
      variant="outlined"
      icon="arrow-anti-clockwise-clock"
      label="Audit log"
      (click)="onAuditLogClicked()"
      (keydown.enter)="onAuditLogClicked()"
      (keydown.space)="$event.preventDefault(); onAuditLogClicked()"
      tabindex="0">
    </mc-button>
  </div>
</div>
<div class="aems-card user-card m-b-16">
  <!-- Grey Header -->
  <div class="card-header">User Information</div>

  <div class="card-body">
    <div class="info-grid">
      <!-- Username + Active -->
      <div class="info-block">
        <div class="value inline">
          {{ user?.username || '-' }}
          <mc-tag fit="small" [appearance]="isActive ? 'info' : 'neutral'" [label]="'Active : ' + (isActive ? 'Yes' : 'No')"> </mc-tag>
        </div>
        <div class="label">User Name</div>
      </div>

      <!-- Email -->
      <div class="info-block">
        <div class="value">{{ user?.emailAddress || '-' }}</div>
        <div class="label">Email Address</div>
      </div>

      <!-- Role -->
      <div class="info-block">
        <div class="value">
          @if (roleTagData.length) {
            <app-tag-with-overflow [data]="roleTagData" [overflowCount]="2"> </app-tag-with-overflow>
          } @else {
            -
          }
        </div>
        <div class="label">Role</div>
      </div>

      <!-- First Name -->
      <div class="info-block">
        <div class="value">{{ user?.firstName || '-' }}</div>
        <div class="label">First Name</div>
      </div>

      <!-- Last Name -->
      <div class="info-block">
        <div class="value">{{ user?.lastName || '-' }}</div>
        <div class="label">Last Name</div>
      </div>

      <!-- Region -->
      @if (!isShopUser) {
        <div class="info-block">
          <div class="value">
            @if (regionTagData.length) {
              <app-tag-with-overflow [data]="regionTagData" [overflowCount]="2"> </app-tag-with-overflow>
            } @else {
              -
            }
          </div>
          <div class="label">Region</div>
        </div>
      }
      <!-- Location Code -->
      <div class="info-block">
        <div class="value">{{ user?.locationCode || '-' }}</div>
        <div class="label">Location Code</div>
      </div>

      <!-- Company -->
      <div class="info-block">
        <div class="value">{{ user?.companyName || '-' }}</div>
        <div class="label">Company</div>
      </div>

      <!-- Shops -->
      @if (isShopUser) {
        <div class="info-block">
          <div class="value">
            @if (shopTagData.length) {
              <app-tag-with-overflow [data]="shopTagData" [overflowCount]="2"> </app-tag-with-overflow>
            } @else {
              -
            }
          </div>
          <div class="label">Shops</div>
        </div>
      }
    </div>
  </div>
</div>

<mc-modal backdropcloseactiondisabled heading="Audit Log" fit="small" dimension="large" [open]="openAuditLog" (closed)="onAuditLogClosed()">
  @if (openAuditLog) {
    <div class="pure-g m-b-16">
      <div class="pure-u-md-6-24 pure-u-lg-4-24 p-r-8">
        <div>{{ user?.userId }}</div>
        <div class="mds-neutral--weak__text-color mds-text--x-small-normal">User ID</div>
      </div>
      <div class="pure-u-md-8-24 pure-u-lg-6-24 p-r-8">
        <div>{{ user?.username }}</div>
        <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Username</div>
      </div>
      <div class="pure-u-md-10-24 pure-u-lg-14-24 p-r-8">
        <div>{{ user?.emailAddress }}</div>
        <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Email</div>
      </div>
    </div>
    <app-master-data-audit-log [transactionCode]="user?.userId?.toString()" [showHeader]="false" [auditLogFetcher]="auditLogFetcher">
    </app-master-data-audit-log>
  }
</mc-modal>
